/**
 * External dependencies
 */
import { useState, useCallback } from "react";
import queryString from "query-string";

/**
 * Internal dependencies
 */
import { isArray } from ".";

export function useUrlParams(key, initialValue = null) {
	const [value, setValue] = useState(
		getQueryStringValue(key, isArray(initialValue)) || initialValue
	);

	const setValueAndQueryString = useCallback(
		(newValue) => {
			setValue(newValue);
			setQueryStringValue(key, newValue);
		},
		[key]
	);

	return [value, setValueAndQueryString];
}

const queryOptions = {
	arrayFormat: "comma",
	parseNumbers: true,
	parseBooleans: true,
	skipEmptyString: true,
};

const getQueryStringValue = (
	key,
	requireArray = false,
	str = window.location.search
) => {
	const values = queryString.parse(str, queryOptions);
	return requireArray && !isArray(values[key]) ? [values[key]] : values[key];
};

const setQueryStringValue = (key, value, str = window.location.search) => {
	const values = queryString.parse(str, queryOptions);
	const isEmptyArray = isArray(value) && value.length === 0;
	const newQsValue = queryString.stringify(
		{ ...values, [key]: isEmptyArray ? "" : value },
		queryOptions
	);
	setQueryStringWithoutPageReload(newQsValue ? `?${newQsValue}` : "");
};

const setQueryStringWithoutPageReload = (str) => {
	const newurl =
		window.location.protocol +
		"//" +
		window.location.host +
		window.location.pathname +
		str;

	window.history.replaceState({ path: newurl }, "", newurl);
};
